<mat-chip [class.active]="values.length > 0" (click)="isOpen = true" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <div class="chip-content">
    @if (fontSet === null) {
      <mat-icon [fontIcon]="icon"></mat-icon>
    } @else {
      <mat-icon [fontSet]="fontSet" [fontIcon]="icon"></mat-icon>
    }
    <span class="clickable text">
      {{ values.length > 0 ? displaySelected(values) : (labelTranslationKey | translate) }}
    </span>
    <mat-icon fontIcon="keyboard_arrow_down"></mat-icon>
    @if (values.length > 0) {
      <button matChipRemove (click)="sendClear()">
        <mat-icon>cancel</mat-icon>
      </button>
    }
  </div>
</mat-chip>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="isOpen = false"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
>
  <div class="overlay-container">
    @if (presets.length > 0) {
      <div class="presets">
        @for (preset of presets; track preset.label) {
          <button type="button" class="preset-button" (click)="applyPreset(preset)">{{ preset.label }}</button>
        }
      </div>
    }
    <div>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label translate="COMMON.NAME"></mat-label>
        <input matInput name="query" autocomplete="off" [(ngModel)]="query" #input />
        {{ input.focus() }}
      </mat-form-field>
    </div>
    <div class="scrollable">
      <mat-selection-list [multiple]="true">
        @for (option of filteredOptions; track option[idKey]) {
          <mat-list-option [selected]="isOptionSelected(option)" [value]="option[idKey]" (selectedChange)="changeSelectionStatus(option, $event)"
            >{{ displayWith(option) }}
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
  </div>
</ng-template>
